import styled from 'styled-components';
import { defaultTheme } from 'constants/theme/defaultTheme';

export const Styles = {
  Wrapper: styled.div`
    overflow-x: auto;
    width: 100%;
    display: flex;
    flex-shrink: 0;
    flex-grow: 1;
  `,
  Button: styled.button<{ active: boolean }>`
    border: none;
    margin-right: ${defaultTheme.spacing(2)};
    cursor: pointer;
    padding: ${defaultTheme.spacing(1)} ${defaultTheme.spacing(4)};
    background-color: ${({ active }) =>
      active ? defaultTheme.colors.healthBlue : defaultTheme.colors.whiteSmoke};
    border-radius: 16px;
    white-space: nowrap;
  `,
};
